import { inject } from '@angular/core';
import { TeacherApiService } from '@shared/services';
import { PERMISSIONS } from '@shared/constants';
import { TableConfig, PLACEHOLDER_FUNCTIONS } from '../generic-p-table.interfaces';

export const teacherMinmaxHistoryTableConfig = (): TableConfig => {
  const teacherApiService = inject(TeacherApiService);

  return {
    title: 'Lịch sử số lớp tối thiểu/tối đa',
    entityName: 'lịch sử số lớp tối thiểu/tối đa',
    service: teacherApiService,
    method: 'getTeacherMinmaxHistories',
    columns: [
      { field: 'employee.code', header: 'Mã NV', width: 'min-w-[80px]', sortable: true, type: 'text' },
      { field: 'profile.fullname', header: 'Họ tên', width: 'min-w-[180px]', sortable: true, type: 'text' },
      { field: 'profile.nickname', header: 'Nickname', width: 'min-w-[150px]', sortable: true, type: 'text' },
      { field: 'minClass', header: 'Số lớp tối thiểu', width: 'min-w-[120px]', sortable: true, type: 'text' },
      { field: 'maxClass', header: 'Số lớp tối đa', width: 'min-w-[120px]', sortable: true, type: 'text' },
      { field: 'fromDate', header: 'Từ ngày', width: 'min-w-[120px]', sortable: true, type: 'date', dateFormat: 'dd/MM/yyyy' },
      { field: 'note', header: 'Ghi chú', width: 'min-w-[200px]', sortable: false, type: 'text' }
    ],
    features: {
      virtualScroll: true,
      toolbar: true
    },
    actions: [
      {
        location: 'toolbar',
        useDefaultStyle: 'add',
        permission: PERMISSIONS.TEACHER_EDIT.code,
        onClick: PLACEHOLDER_FUNCTIONS.OPEN_NEW
      },
      {
        location: 'row',
        useDefaultStyle: 'edit',
        permission: PERMISSIONS.TEACHER_EDIT.code,
        onClick: PLACEHOLDER_FUNCTIONS.EDIT
      }
    ]
  };
};
